export const publicContainer = {
  name: '公共集装箱 |||| 公共集装箱',
  fields: {
    title: '集装箱信息',
    containerCode: '集装箱代码',
    totalShipments: '总货件数',
    totalWeight: '总重量',
    totalVolume: '总体积',
    shipmentsList: '货件清单',
    orderInfo: '订单信息',
    images: '图片',
    notes: '备注',
    productName: '产品名称',
    numberOfPacks: '包装数量',
    totalDimension: '总尺寸',
    totalWeightColumn: '总重量',
    status: '状态',
    orderCreatedDate: '订单创建日期',
    shipmentCreatedDate: '货件创建日期',
    confirmationImage: '确认图片',
    noImages: '无图片',
    noShipments: '此集装箱中没有货件。',
    invalidCode: '集装箱代码无效或已过期',
    missingCode: 'URL中未找到集装箱代码',
    loadingError: '加载数据错误',
    index: '序号',
    mvd: 'MVD',
    order: '订单',
    shipment: '货件',
    inWarehouse: '在仓库',
  },
  statuses: {
    ALL: '全部',
    IN_FROM_WAREHOUSE: '在源仓库',
    TURN_AROUND: '回程',
    LOADING: '装载中',
    IN_CONT: '在集装箱',
    DEPARTED: '已出发',
    ARRIVED: '已到达',
    RETURNED: '已返回',
    IN_TO_WAREHOUSE: '在目标仓库',
    ON_DELIVERY: '正在交付',
    DELIVERED: '已交付',
    COMPLETED: '已完成',
    LOST: '丢失',
  },
}
